import { render, staticRenderFns } from "./ModelsAdd.vue?vue&type=template&id=6431c5c6&scoped=true&"
import script from "./ModelsAdd.vue?vue&type=script&lang=js&"
export * from "./ModelsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6431c5c6",
  null
  
)

export default component.exports